var GallerySwiper = class extends HTMLElement {
    constructor() {
        super();
        // Solo inicializar en móvil o donde decidas aplicar swiper
        this.initSwiper();
    }

    initSwiper() {
        // Inicializa primero el swiper de miniaturas
        const thumbsSwiper = new Swiper('.gallery-thumbs', {
            direction: 'vertical', // Cambia a vertical si prefieres en mobile también
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesProgress: true,
            navigation: {
                nextEl: '.swiper-thumbs-next',
                prevEl: '.swiper-thumbs-prev',
            },
        });


        if (window.matchMedia("(max-width: 999px)").matches) {
            const swiper = new Swiper('.product__media.swiper', {
                // Optional parameters
                loop: true,

                // And if we need scrollbar
                scrollbar: {
                    el: '.swiper-scrollbar',
                },
            });
        }

        document.querySelectorAll('.product__thumbnail-swiper .swiper-slide').forEach(slide => {
            slide.addEventListener('click', () => {
                const targetId = slide.getAttribute('data-target');
                const targetElement = document.querySelector('[data-target-scrollto="' + targetId + '"]');
                if (targetElement) {
                    targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            });
        });
    }
};

window.customElements.define("gallery-swiper", GallerySwiper);
